export class ArquivoMetadados {
    id: number;
	nmArquivo: string;
	dsTipoArquivo: string;
	nrTamanhoArquivo: number;
	dtCriacao: Date;
	hash: string
	idInstituicao: number;
	tipo: string;
}